const { default: Purchase } = require("./Purchase")

export default Purchase